import { EscalationsGroupInterface, RoleInterface, RoleInterfaceMap } from "@swivl-mono/types";
import React from "react";
import { FaPlus, FaTimes } from "react-icons/fa";

import EscalationsModel from "../../../../../Models/Escalations/Escalations.Model";
import "../../../../../Views/Settings/Escalations/Groups/EscalationGroupView.scss";

interface Props {
  roles: RoleInterfaceMap;
  group: EscalationsGroupInterface;
}

export function EditRolesView(props: Props) {
  const { group, roles } = props;
  const [isAddingRole, setIsAddingRole] = React.useState(false);
  const addRole = (roleSlug: string) => {
    let newGroup = { ...group };
    if (!newGroup.roles) {
      newGroup.roles = [];
    }
    if (newGroup.roles.includes(roleSlug)) {
      return;
    }
    newGroup.roles.push(roleSlug);
    EscalationsModel.updateGroup(newGroup, true);
    // EscalationsModel.addRoleToGroup(group.id, role
  };
  const removeRole = (roleSlug: string) => {
    let newGroup = { ...group };
    if (!newGroup.roles) {
      newGroup.roles = [];
    }
    if (!newGroup.roles.includes(roleSlug)) {
      return;
    }
    newGroup.roles = newGroup.roles.filter((slug) => slug !== roleSlug);
    EscalationsModel.updateGroup(newGroup, true);
    // EscalationsModel.removeRoleFromGroup(group.id, roleSlug)
  };
  return (
    <div className="AddRolesView mb-4">
      {!group.roles || group.roles.length === 0 ? (
        <div className="noRoles">⚠️ No Roles Set</div>
      ) : (
        <>
          {group.roles.map((roleSlug) => {
            const role = roles[roleSlug];
            if (!role) {
              return (
                <div key={roleSlug} className="missingRole bg-red-400">
                  Unknown Role {roleSlug}
                </div>
              );
            }
            return (
              <div key={roleSlug} className="role">
                <b>{role.name}</b>
                <FaTimes
                  className="removeRole"
                  onClick={() => {
                    if (
                      window.confirm(
                        `Are you sure you want to remove ${role.name} from this group? Agents with this role will no longer get escalations.`
                      )
                    ) {
                      removeRole(role.slug);
                    }
                  }}
                />
              </div>
            );
          })}
        </>
      )}

      {isAddingRole ? (
        <div className="rolePicker flex">
          {Object.values(roles)
            .filter((role) => {
              return !group.roles || !group.roles.includes(role.slug);
            })
            .map((role) => {
              return (
                <div key={role.slug} className="role flex flex-row">
                  {role.name}{" "}
                  <FaPlus
                    className="add"
                    onClick={() => {
                      setIsAddingRole(false);
                      addRole(role.slug);
                    }}
                  />
                </div>
              );
            })}
        </div>
      ) : (
        <div className="addRole" onClick={() => setIsAddingRole(true)}>
          + Add Role
        </div>
      )}
    </div>
  );
}
